export default function Contact() {
  return (
    <footer id="contact" className="bg-gradient-to-b from-white to-gray-50 pt-10 md:pt-16 pb-6 md:pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
          <div>
            <h4 className="text-base md:text-lg font-bold text-[#1B5E20] mb-3 md:mb-4 pb-2 border-b-2 border-[#D4AF37]">
              عن الملتقى
            </h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="#about" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  الرؤية والرسالة
                </a>
              </li>
              <li>
                <a href="#objectives" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  الأهداف الاستراتيجية
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  الشركاء والرعاة
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold text-[#1B5E20] mb-3 md:mb-4 pb-2 border-b-2 border-[#D4AF37]">
              البرنامج
            </h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="#schedule" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  الجدول الزمني
                </a>
              </li>
              <li>
                <a href="#schedule" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  المتحدثون
                </a>
              </li>
              <li>
                <a href="#schedule" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  ورش العمل
                </a>
              </li>
              <li>
                <a href="#schedule" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  المعرض المصاحب
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold text-[#1B5E20] mb-3 md:mb-4 pb-2 border-b-2 border-[#D4AF37]">
              المشاركة
            </h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="#registration" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  التسجيل في الملتقى
                </a>
              </li>
              <li>
                <a href="#registration" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  فرص الرعاية
                </a>
              </li>
              <li>
                <a href="#registration" className="text-gray-600 hover:text-[#1B5E20] transition-colors text-sm cursor-pointer">
                  التطوع
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold text-[#1B5E20] mb-3 md:mb-4 pb-2 border-b-2 border-[#D4AF37]">
              تواصل معنا
            </h4>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-mail-line text-base md:text-lg text-[#1B5E20] mt-1"></i>
                <div>
                  <div className="text-xs text-gray-500 mb-1">البريد الإلكتروني</div>
                  <a href="mailto:info@dfy.org.sa" className="text-xs md:text-sm text-gray-700 hover:text-[#1B5E20] transition-colors cursor-pointer break-all">
                    info@dfy.org.sa
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-phone-line text-base md:text-lg text-[#1B5E20] mt-1"></i>
                <div>
                  <div className="text-xs text-gray-500 mb-1">رقم الهاتف</div>
                  <a href="tel:+966592544688" className="text-xs md:text-sm text-gray-700 hover:text-[#1B5E20] transition-colors cursor-pointer" dir="ltr">
                    +966 59 254 4688
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 md:gap-3">
                <i className="ri-map-pin-line text-base md:text-lg text-[#1B5E20] mt-1"></i>
                <div>
                  <div className="text-xs text-gray-500 mb-1">العنوان</div>
                  <span className="text-xs md:text-sm text-gray-700">المدينة المنورة، المملكة العربية السعودية</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-2">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/d635066a0d023485209a64426ae9d593/176da29f8d5080f47475d127a4d5e329.png" 
                alt="شعار جمعية ديوان الشبابية" 
                className="w-96 md:w-[28rem] h-auto object-contain"
              />
            </div>

            <div className="flex flex-col items-center md:items-end gap-3 md:gap-4">
              <div className="flex items-center gap-3 md:gap-4">
                <a
                  href="https://twitter.com/d4ymed"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gray-100 hover:bg-[#1B5E20] flex items-center justify-center transition-all group cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-base md:text-lg text-gray-600 group-hover:text-white"></i>
                </a>
                <a
                  href="https://instagram.com/d4ymed"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gray-100 hover:bg-[#1B5E20] flex items-center justify-center transition-all group cursor-pointer"
                >
                  <i className="ri-instagram-line text-base md:text-lg text-gray-600 group-hover:text-white"></i>
                </a>
                <a
                  href="https://youtube.com/@d4ymed"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gray-100 hover:bg-[#1B5E20] flex items-center justify-center transition-all group cursor-pointer"
                >
                  <i className="ri-youtube-line text-base md:text-lg text-gray-600 group-hover:text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
